<style lang="scss">
.zoezi-resourcebooking .zoezi-button-thin .v-btn__content{
    max-width:100%;
  .text-start{
    max-width:calc(100% - 38px);
    .z-small-font{
      overflow:hidden;
      text-overflow:ellipsis;

    }
  }
}
</style>

<template>

    <div ref="top" class="z-mobile-negative-margins" v-if="services.length">
        <v-row v-if="showFilterRow" class="mx-0">
            <v-col cols=3>
                <filter-button :title="$translate('Time')" icon="mdi-calendar-clock" ref="filterButtonDate">
                    <template #items="{hide}">
                        <date-picker v-model="selectedDate" :min-date="$store.state.now30s.clone().clearTime()" week @change="dateChanged($event); hide()" />

                        <div class="mx-2 mt-4">
                            <filter-button-row icon="mdi-calendar-today" :name="$translate('All day')" :value="[0,DAY_PERIODS.length].includes(selectedDayPeriods.length)" />
                            <filter-button-row
                                v-for="item in DAY_PERIODS"
                                :key="item.id"
                                :color="item.color"
                                :name="$translate(item.title)"
                                :icon="item.icon"
                                :value="selectedDayPeriods.includes(item.id)"
                                @input="setItem(selectedDayPeriods, item.id, $event)"
                            />
                        </div>
                    </template>
                </filter-button>
            </v-col>
            <v-col cols=3>
                <filter-button v-model="selectedServices" :items="sortedServices" :title="$translate('Type')" icon="mdi-chart-timeline" />
            </v-col>
            <v-col cols=3>
                <filter-button v-model="selectedStaffs" :items="sortedStaffs" :title="$translate('Practitioner')" icon="mdi-account-question-outline" />
            </v-col>
            <v-col cols=3 v-if="showSiteFilter">
                <filter-button
                    :value="filterSites"
                    @input="setProp('filterSites', $event)"
                    :title="$translate('Location')"
                    icon="mdi-map-marker-radius-outline"
                    :items="sites"
                    search
                    :searchText="$translate('Search location')"
                    :show-color-image-circle="false"
                />
            </v-col>
        </v-row>

        <div class="d-flex align-center">
            <v-btn icon color="primary" @click="prevWeek" v-if="!isCurrentWeek"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <span class="flex-grow-1 text-center text-h5">{{$translate('Week')}} {{selectedDate.getWeekNumber()}}</span>
            <v-btn class="align-self-end" icon color="primary" @click="nextWeek"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </div>

        <v-alert v-if="isBlocked" dense text type="error" border="left" icon="mdi-alert-circle">
            {{ $translate('You are blocked and can not book') }}
        </v-alert>

        <div class="d-flex align-center flex-column" v-if="!wholeWeekSlots.length && loadingSlots">
            <div class="flex-grow-1 text-center text-h5">{{$translate('Fetching available times')}}</div>
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>

        <v-sheet v-if="!wholeWeekSlots.length && !loadingSlots && showNextButton" class="zoezi-resourcebooking-no-times pa-4 black--text" color="#f5f5f5">
            <div v-if="reloading">
                <img class="v-icon" style="height: 40px;" src="/assets/img/loader.svg" />
                <span class="text-subtitle-1 ml-2">{{$translate('Fetching available times')}}</span>
            </div>
            <div v-else>
                <v-icon x-large color="#4c4c4c">mdi-calendar-remove-outline</v-icon><span class="text-subtitle-1 ml-2">{{$translate('There are no available times this week')}}</span>
            </div>
        </v-sheet>

        <v-expansion-panels v-else flat accordion :multiple="false">
            <div v-for="x in wholeWeekSlots" :key="x.date" class="fill-width v-expansion-panels--accordion v-expansion-panels--flat">
                <div class="d-flex flex-row">
                    <!-- FIXME: Hardcoded 11px -->
                    <hr class="v-divider theme--light" style="margin-top: 11px" />
                    <span class="zoezi-resourcebooking-day-title text-subtitle-2 px-2">
                        {{formatTimeLonger(x.date)}}
                    </span>
                    <hr class="v-divider theme--light" style="margin-top: 11px" />
                </div>
                <v-expansion-panel v-for="(y,key) in x.services" :key="key">
                    <v-expansion-panel-header expand-icon="" class="pa-0">
                        <template #default="{open}">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    <div class="zoezi-resourcebooking-service-name font-weight-bold px-2">{{y.service.name}}</div>
                                    <v-row no-gutters class="px-2">
                                        <v-col cols=7>
                                            <v-icon small class="mr-1" color="primary">mdi-clock-outline</v-icon>{{y.service.duration}} {{$translate('MINUTES_SHORT')}}
                                        </v-col>
                                        <v-col cols=5 v-if="showPrice">
                                            <v-icon small class="mr-1" color="primary">mdi-tag-outline</v-icon>{{y.service.price | price}}
                                        </v-col>
                                    </v-row>
                                </div>
                                <div>
                                    <div class="d-flex align-center pr-2">
                                        <zoezi-button
                                            block
                                            thin
                                            :text="open ? $translate('Hide times') : $translate(y.numSlots == 1 ? 'SHOW_TIME' : 'SHOW_TIMES').format(y.numSlots)"
                                            :icon="`mdi-chevron-${open ? 'up' : 'down'}`" right
                                            class="zoezi-resourcebooking-times-button"
                                            @click="ecommerceViewItemFunction(y)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="z-dense">
                        <v-card class="pa-1 mb-4 d-flex flex-wrap">
                            <v-btn
                                v-for="slot in onePerStaff(y.slots)" :key="slot.key"
                                :outlined="!slot.reserved" :color="slot.reserved && !slot.reserving ? 'success' : (isBlocked ? 'error' : 'primary')" class="zoezi-button-thin zoezi-button-fill-space ma-1 px-1 align-self-start" height="36px" width="150px" left @click="slotClicked(slot)" :loading="slot.reserving" :disabled="isReserving">
                                <v-avatar size="30">
                                    <img class="zoezi-staff-image" :src="$api.getImageUrl(slot.staff.imagekey, 100)" style="width:30px; height:30px" />
                                </v-avatar>

                                <div class="ma-1 text-start">
                                    <div v-text="slot.start.hhmm()" class="font-weight-bold"  />
                                    <div v-text="slot.staff.name" class="z-small-font" />
                                </div>
                            </v-btn>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </div>
        </v-expansion-panels>

        <div v-if="showNextButton" class="d-flex justify-end mt-6">
            <zoezi-button v-if="!showNextWeek" :text="$translate('Next available time')" @click="nextAvailable" thin large class="mr-2" />
            <zoezi-button v-else :text="$translate('Next week')" @click="nextWeek" thin large class="mr-2" />
        </div>

        <v-sheet v-else-if="!loadingSlots && filteredServices.length == 1" class="zoezi-resourcebooking-no-times pa-4 black--text" color="#f5f5f5">
            <v-icon x-large color="#4c4c4c">mdi-calendar-remove-outline</v-icon><span class="text-subtitle-1 ml-2">{{$translate('There are no available times at all in the future')}}</span>
        </v-sheet>

        <bottom-dialog v-model="showCheckout" scrollable max-width="850px" :dialog="!$vuetify.breakpoint.mobile" :persistent="!almostdone" v-if="showCheckout">
            <v-card class="zoezi-bottom-sheet" tile elevation="0">
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        <span v-if="!almostdone">{{$translate('Complete booking')}}</span>
                        <v-btn icon @click="showCheckout = false" class="float-right" v-if="!checkoutLoading"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>

                <v-card-text :class="{'px-2': !almostdone && $vuetify.breakpoint.mobile, 'px-0': almostdone, 'pb-0': almostdone, primary: almostdone }" class="z-no-x-scroll" style="min-height: 50vh">
                    <!-- <resource-booking-header v-if="$vuetify.breakpoint.mobile && currentStep < steps.findIndex(s => s.id =='checkout')" class="mx-2 mt-2" :service="services.find(s => s.id == reservations[0].bookings[0].rbservice_id)" :start="reservations[0].bookings[0].start" :staff="staffs.find(s => s.id == reservations[0].bookings[0].staff_id)" /> -->
                    <checkout
                        ref="checkout"
                        :useCart="useCart"
                        :cartName="cartName"
                        class="overflow-y-auto"
                        :items="checkoutItems"
                        expand-first-item
                        :show-summary="true"
                        :show-back-link="false"
                        :show-payment-button="false"
                        :show-sum="showPrice"
                        :force-done="almostdone"
                        @done="checkoutDone"
                        @almostdone="almostdone = true"
                        @loading="checkoutLoading = $event"
                        @cost="cost = $event"
                        @readyToPay="readyToPay = $event"
                        @readyToPayExceptPaymentMethod="readyToPayExceptPaymentMethod = $event"
                        @changeNumberOfItems="changeNumberOfItems"
                        content-target="checkoutcontent"
                        :dialog="true"
                        :new-style-done-dialog="true"
                        @reservation-timeout="reservationTimeout"
                    >
                        <template #done="{context: selectedSlot}">
                            <v-sheet class="zoezi-resourcebooking-done" color="primary">
                                <div class="zoezi-resourcebooking-done-header-row mb-4 d-flex justify-center primarytext--text">
                                    <i class="done-icon" :class="{active: animateDone}" style="font-size: 52px"></i>
                                </div>

                                <v-row class="zoezi-resourcebooking-done-resource-row" no-gutters>
                                    <v-col align-self="end" style="max-width: 80px">
                                        <v-avatar size="60" class="mx-2">
                                            <v-auto-img class="zoezi-staff-image" :src="selectedSlot.staff.imagekey" />
                                        </v-avatar>
                                    </v-col>
                                    <v-col style="max-width:350px;">
                                        <v-card class="ma-2 pointer-lb">
                                            <v-card-text class="pa-3">
                                                <div class="zoezi-resourcebooking-done-welcome primary--text font-weight-bold">{{$translate('Warm welcome!')}}</div>
                                                <div class="font-weight-bold">{{selectedSlot.service.name}}</div>
                                                <div><v-icon small class="mr-1">mdi-calendar-month-outline</v-icon>{{formatTime(selectedSlot.start, selectedSlot.period)}}</div>
                                                <div><v-icon small class="mr-1">mdi-clock-outline</v-icon>{{$translate("At {0} o'clock".format(selectedSlot.start.hhmm()))}}</div>
                                                <div class="my-2">&ndash;{{selectedSlot.staff.name}}</div>

                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-row class="zoezi-resourcebooking-done-location-row mt-2" no-gutters>
                                    <v-col class="ml-auto" style="max-width:350px">
                                        <v-card class="ma-2 pointer-rb">
                                            <v-card-text class="pa-3">
                                                <!-- iframe width="256" style="width:100%" height="144" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=16.002163589000705%2C58.19858264611028%2C16.005524396896366%2C58.20006109657332&amp;layer=mapnik" ></iframe -->
                                                <div>
                                                    <div>{{contactinfo.visit_address}}</div>
                                                    <div>{{contactinfo.visit_zipCode}} {{contactinfo.visit_city}}</div>
                                                </div>
                                                <v-btn color="primary" block class="mt-2" v-on:click="openGoogle()">{{$translate('Show on Google')}} <v-icon class="ml-2">mdi-export</v-icon></v-btn>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col align-self="end" style="max-width:50px;">
                                        <v-icon x-large class="mb-4" color="primarytext">mdi-map-marker-outline</v-icon>
                                    </v-col>

                                </v-row>

                                <v-btn v-if="numBookings"
                                       @click="gotoMyPages"
                                       color="primary"
                                       fab
                                       bottom
                                       right
                                       fixed
                                       :style="{bottom: $vuetify.breakpoint.mobile ? 'calc(56px + 16px)' : '16px'}"
                                >
                                    <v-badge :key="numBookings" :content="numBookings" color="red" :value="numBookings" class="animate__animated animate__heartBeat" left>
                                        <v-icon color="primarytext">mdi-ticket</v-icon>
                                    </v-badge>
                                </v-btn>

                            </v-sheet>
                        </template>

                        <template #content>
                            <stepper-content v-model="currentStep" :steps="steps">
                                <template #questions>
                                    <v-form @submit.prevent="questionsDone && $refs.stepper.nextClicked()" v-model="questionsDone">
                                        <v-expansion-panels v-model="expandedQuestionPanel" accordion flat>
                                            <v-expansion-panel v-for="(reservation,index) in reservations.filter(r => r.questions && Object.keys(r.questions).length)" :key="index">
                                                <expansion-panel-header
                                                    icon="mdi-comment-question-outline"
                                                    :title="$translate('Supplementary questions for {0}').format(services.find(s => s.id == reservation.bookings[0].rbservice_id).name)"
                                                    :subtitle="$translate('Answer the questions to proceed')"
                                                />
                                                <v-expansion-panel-content class="z-dense">
                                                    <form-field v-for="q in reservation.questions" :key="q.name" :field="q" star v-model="q.value" />
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-form>
                                </template>

                                <template #optional_resources>
                                    <OptionalResources
                                        style="max-height: 428px"
                                        :disabled="isReserving"
                                        :resource-name="steps[currentStep].context.resource_name"
                                        :resource-ids="steps[currentStep].context.resource_ids"
                                        :start-time="steps[currentStep].context.start"
                                        :end-time="steps[currentStep].context.end"
                                        :all-resources="steps[currentStep].context.service.resources"
                                        :selected-resource-ids="steps[currentStep].context.selected_resource_ids"
                                        @select="(resource_id, selected) => optionalResourceSelected(steps[currentStep].context.reservation, steps[currentStep].context.booking, resource_id, selected)"
                                    />
                                </template>

                                <template #extra_person>
                                    <div class="mb-2 font-weight-bold">{{$translate('You have the opportunity to schedule more at the same time and resource. Do you want to do that?')}}</div>

                                    <div><v-icon>mdi-account-question-outline</v-icon><span class="ml-2">{{$translate('Who to book?')}}</span></div>

                                    <div class="z-rounded-box my-2">
                                        <div class="pa-2 d-flex">
                                            <div class="ml-2 flex-grow-1">
                                                <span class="font-weight-bold" v-if="extraPersons.length == 0">{{$store.state.user && $store.state.user.name}} ({{$translate('You')}})</span>
                                                <span class="font-weight-bold" v-else>{{$translate('{0} people including you').format(extraPersons.length + 1)}}</span>
                                            </div>
                                        </div>

                                        <div class="px-2 py-1 d-flex align-center" v-for="(person, index) in extraPersons" :key="index">
                                            <v-text-field
                                                v-model="person.name"
                                                :label="$translate('Name')"
                                                dense
                                                :rules="[v => !!v || $translate('Write the name of the participant')]"
                                            />
                                            <v-btn class="ml-3" @click="removeExtraPerson(index)" icon>
                                                <v-icon small>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>


                                    <div v-if="checkingAvailability" class="d-flex align-center">
                                        <v-progress-circular indeterminate size="24"></v-progress-circular>
                                        <span class="ml-2">{{$translate('Updating...')}}</span>
                                    </div>
                                    <div>
                                        {{seatsLeft == 1 ? $translate('There is currently 1 spot left') : $translate('There are currently {0} seats left').format(seatsLeft)}}
                                    </div>

                                    <v-btn color="primary" :outlined="true" block class="zoezi-button-thin" @click="addExtraPerson" :disabled="!seatsLeft || isReserving || checkingAvailability">
                                        <v-icon left color="primary">mdi-account-plus</v-icon>
                                        {{$translate('Add participant')}}
                                    </v-btn>
                                </template>

                                <template #products>
                                    <v-expansion-panels v-model="expandedProductPanel" accordion flat>
                                        <v-expansion-panel class="mt-2" v-for="reservation in reservations.filter(r => additionalProducts[r.key].length)" :key="reservation.key">
                                            <expansion-panel-header
                                                icon="mdi-tag-plus-outline"
                                                :title="$translate('Buy more for {0}').format(services.find(s => s.id == reservation.bookings[0].rbservice_id).name)"
                                                :subtitle="$translate('Buy the products you need')"
                                            />
                                            <v-expansion-panel-content class="z-dense">
                                                <additional-product-list :products="additionalProducts[reservation.key]" :basket="reservation.basket" :total-basket="productsInBasket" :show-added-banner="false" />
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </template>
                                <template #checkout>
                                    <portal-target name="checkoutcontent"/>
                                </template>
                            </stepper-content>
                        </template>
                    </checkout>
                </v-card-text>
                <v-card-actions v-if="!almostdone">
                    <stepper v-model="currentStep" :steps="steps" :fixed="$vuetify.breakpoint.mobile" @cancel="showCheckout=false" ref="stepper" :show="!almostdone" :disabled="checkoutLoading" />
                </v-card-actions>
            </v-card>
        </bottom-dialog>

        <div v-if="showBookTimesSheet && !showCheckout" style="background: white; position: fixed; z-index: 250" :style="{left: $vuetify.breakpoint.mobile ? 0 : 'calc(50vw - 350px)', width: $vuetify.breakpoint.mobile ? '100vw' : '700px', bottom:  $vuetify.breakpoint.mobile ? '56px': '0'}">
            <v-sheet color="white" class="d-flex pa-2 elevation-8">
                <v-row dense>
                    <v-col cols=6>
                        <v-btn outlined color="primary" class="zoezi-button-thin" x-large block @click="unreserveAll(false)">{{$translate('Cancel')}}</v-btn>
                    </v-col>
                    <v-col cols=6>
                        <zoezi-button :key="numberOfBookings" :text="numberOfBookings == 1 ? $translate('Book selected time') : $translate('Book {0} selected times').format(numberOfBookings)" thin x-large class="mx-1 animate__animated animate__tada" block @click="showCheckout = true" />
                    </v-col>
                </v-row>
            </v-sheet>
        </div>
    </div>
    <v-card v-else-if="$root.edit" color="zoezi-edit-color" dark height="100">
        <v-card-title>{{$translate('Select services for resource booking')}}</v-card-title>
    </v-card>

</template>

<script>
import Checkout from '../views/Checkout.vue'
import DatePicker from '../components/DatePicker.vue'
import ZoeziButton from '../views/Button.vue'
import BottomDialog from '../components/BottomDialog.vue'
import Stepper from '../views/Stepper.vue'
import AdditionalProductList from '../views/AdditionalProductList.vue'
import ExpansionPanelHeader from '../views/ExpansionPanelHeader.vue'
import FormField from '../components/FormField.vue'
import FilterButton from '../components/FilterButton.vue'
import FilterButtonRow from '../components/FilterButtonRow.vue'
import {getName, formatPrice, mergeBaskets, getRandomId} from '../util.js'
import StepperContent from './StepperContent.vue'
import OptionalResources from './OptionalResources.vue'
import {DAY_PERIODS} from '../util.js'
import { intersection, isEqual } from 'lodash';
import * as Sentry from '@sentry/browser';

export default {

    name: 'zoezi-resourcebooking',

    zoezi: {
        title: 'Resource booking',
        icon: 'mdi-book',
        addon: 'ResourceBooking'
    },

    components: {
        Checkout,
        DatePicker,
        ZoeziButton,
        BottomDialog,
        Stepper,
        AdditionalProductList,
        ExpansionPanelHeader,
        FormField,
        StepperContent,
        FilterButton,
        FilterButtonRow,
        OptionalResources
    },

    props: {
        categoryId: {
            title: 'Category',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getResourceBookingCategories(),
                selectFirst: true
            }
        },
        serviceIds: {
            title: 'Services',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                filter: (x, props) => ( props.categoryId ? x.category_id == props.categoryId : true) && x.show && x.active,
                getItems: () => window.$zoeziapi.get('/api/resourcebooking/service/get/all'),
                selectFirst: true
            }
        },
        showFilterRow: {
            title: 'Show filter row',
            type: Boolean,
            default: true
        },
        defaultDayPeriods: {
            title: 'Time of the day',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'title',
                value: 'id',
                nosort: true,
                getItems() {
                    return new Promise((resolve) => resolve(DAY_PERIODS));
                }
            },
            default: () => []
        },
        defaultServices: {
            title: 'Preselected services',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                filter: (x, props) => ( props.categoryId ? x.category_id == props.categoryId : true) && x.show,
                getItems: () => window.$zoeziapi.get('/api/resourcebooking/service/get/all')
            },
            default: () => []
        },
        filterSites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true
            },
            default: () => []
        },
        showSiteFilter: {
            title: 'Show site filter',
            type: Boolean,
            default: true
        },
        siteId: {
            title: 'Site',
            type: Number,
            default: 1
        },
        useCart: {
            title: 'Use shopping cart',
            type: Boolean,
            default: true
        },
        cartName: {
            title: 'Namn på varukorg',
            type: String,
            default: ''
        }
    },

    data: () => ({
        currentStep: 0,
        almostdone: false,
        selectedDate: Date.today(),
        loadingSlots: true,
        firstFreeDate: null,
        showNextButton: false,
        showNextWeek: false,
        category: null,
        services: [],
        dayPeriods: DAY_PERIODS,

        // FIXME: Bundle together into filter: {period, services, staffs} ?
        selectedDayPeriods: [],
        selectedServices: null,
        selectedStaffs: null,

        slots: [],
        selectedDateAndService: null,

        showCheckout: false,
        selectedSlot: null,
        showServiceDescription: false,
        reservations: [],

        showDatePicker: false,

        products: [],
        expandedQuestionPanel: 0,
        expandedProductPanel: 0,
        checkoutLoading: false,
        cost: null,
        showBookTimesSheet: false,
        readyToPay: false,
        readyToPayExceptPaymentMethod: false,
        questionsDone: false,
        unsubscribe: null,
        animateDone: false,
        reloading: false,
        requestIndex: 1,
        throttling: null,
        extraPersons: [],
        seatsLeft: null,
        checkingAvailability: false,
        selectedSlotHasCapacity: null,
        bookingId: getRandomId(8) // Used to identify the booking in the cart (tmp_id)
    }),
    watch: {
        siteId() {
            this.unreserveAll();
        },
        categoryId: {
            immediate: true,
            handler() {
                this.$booking.getResourceBookingCategories().then(cats => {
                    this.category = cats.find(c => this.categoryId == c.id);
                })
            }
        },
        serviceIds: {
            immediate: true,
            handler() {
                this.$api.get('/api/public/resourcebooking/service/get', {category: this.categoryId}).then(services => {
                    this.services = this.serviceIds ? this.serviceIds.map(id => services.find(s => s.id == id)).filter(x => x) : []
                    this.setServices(this.defaultServices);
                })
            }
        },
        defaultDayPeriods: {
            immediate: true,
            handler() {
                this.selectedDayPeriods = this.defaultDayPeriods.concat();
            }
        },
        defaultServices: {
            immediate: true,
            handler() {
                this.setServices(this.defaultServices);
            }
        },
        showCheckout() {
            if (!this.showCheckout) {
                this.reset();
            }
        },
        selectedDate() {
            this.$vuetify.goTo(this.$refs.top);
            this.getFreeSlots();
        },
        selectedServices() {
            this.getFreeSlots();
        },
        filteredStaffs() {
            this.getFreeSlots();
        },
        filterSites(newValue, oldValue) {
            if (!isEqual(newValue, oldValue)) {
                this.unreserveAll();
                this.getFreeSlots();
            }
        },
        reservations() {
            if (this.reservations && this.reservations.length) {
                if (this.category && !this.category.multiBooking) {
                    this.currentStep = 0;
                    this.showCheckout = true;
                } else {
                    if (this.category && this.category.multiBooking) {
                        this.showBookTimesSheet = true;
                    }
                }
            } else {
                this.showBookTimesSheet = false;
            }

            this.reservations.forEach(r => {
                let service = this.services.find(s => s.id == r.bookings[0].rbservice_id);
                if (!r.questions) {
                    let questions = {};
                    service.extendedInfo.forEach(q => {
                        q = Object.assign({}, q, {value: '', title: q.name});
                        questions[q.name] = q;
                    })
                    this.$set(r, 'questions', questions);
                }

                if (!r.basket) {
                    this.$set(r, 'basket', {})
                }

                if (service.additional_products) {
                    service.additional_products.forEach(id => this.$set(r.basket, id, []));
                    let ids = String(service.additional_products.filter(id => !this.products.find(p => p.id == id)));
                    if (ids) {
                        this.$api.get('/api/public/trainingcard/type/get', {ids}).then(products => {
                            products.forEach(p => {
                                if (!this.products.find(x => x.id == p.id)) {
                                    this.products.push(p);
                                }
                            })
                        });
                    }
                }
            })
        },
        almostdone(almostdone) {
            if (almostdone) {
                setTimeout(() => this.animateDone = true, 500)
            } else {
                this.animateDone = false;
            }
        }
    },
    computed: {

        DAY_PERIODS() {
            return DAY_PERIODS;
        },
        sortedServices() {
            return this.services.concat().sort((a,b) => a.name.localeCompare(b.name));
        },
        staffs() {
            let staffs = [];
            this.services.forEach(s => {
                s.staffs.forEach(staff => {
                    staff.name = getName(staff);
                    if (!staffs.find(s => s.id == staff.id)) {
                        staffs.push({id: staff.id, name: staff.name, imagekey: staff.imagekey, sites: staff.sites});
                    }
                })
            });

            return staffs;
        },
        staffsForSite() {
            if (!this.filterSites || this.filterSites.length == 0) {
                return this.staffs;
            }

            return this.staffs.filter(staff => intersection(staff.sites, this.filterSites).length > 0);
        },
        filteredStaffs() {
            return this.staffsForSite.filter(staff => {
                if (!this.selectedStaffs || this.selectedStaffs.length == 0) {
                    return true;
                }

                return !!this.selectedStaffs.find(x => x == staff.id);
            });
        },
        sortedStaffs() {
            return this.staffsForSite.concat().sort((a,b) => a.name.localeCompare(b.name));
        },
        filteredServices() {
            return this.services.filter(x => {
                if (!this.selectedServices || this.selectedServices.length == 0) {
                    return true;
                }

                return this.selectedServices.find(s => s == x.id);
            });
        },
        reservationSlots() {
            // slot: {start, end, service, staffs: [], key, period}
            let res = [];
            this.reservations.forEach(r => {
                r.bookings.forEach(b => {
                    let startHour = Date.newFull(b.start).getHours();

                    let a = {
                        start: Date.newFull(b.start),
                        end: Date.newFull(b.end),
                        service: this.services.find(s => s.id == b.rbservice_id),
                        staffs: [b.staff_id],
                        key: b.rbservice_id + '_' + b.start,
                        period: DAY_PERIODS.find(d => startHour >= d.start && startHour < d.end),
                        reserved: true,
                        reserving: b.reserving
                    };
                    res.push(a);
                })
            })
            return res;
        },
        slotsAndReservations() {
            return this.slots.concat(this.reservationSlots);
        },
        periodFilteredSlots() {
            return this.slotsAndReservations.filter(slot => {
                if (slot.start.getTime() < this.selectedDate.getTime()) {
                    return false;
                }

                if (this.selectedDayPeriods.length == 0) {
                    return true;
                }

                return !!this.selectedDayPeriods.find(x => x == slot.period.id);
            });
        },
        isCurrentWeek() {
            let week = this.$store.state.now30s.getDateIntervalForWeek();
            return this.selectedDate.withinRange(week[0], week[1]);
        },
        nextWeekNumber() {
            return this.selectedDate.clone().addDays(7).monday().getWeekNumber();
        },
        wholeWeekSlots() {
            let week = this.selectedDate.getDateIntervalForWeek();
            let slotsInWeek = this.periodFilteredSlots.filter(slot => slot.start.withinRange(week[0], week[1]));

            let periods = []; // {date: '2020-11-01', services: {17: {service: {}, slots: [], numSlots: 22}}
            slotsInWeek.forEach(slot => {
                let sp = periods.find(p => p.date == slot.start.yyyymmdd());
                if (!sp) {
                    sp = {date: slot.start.yyyymmdd(), services: {}};
                    periods.push(sp);
                }

                if (!sp.services[slot.service.id]) {
                    sp.services[slot.service.id] = {service: slot.service, slots: [], numSlots: 0}
                }
                sp.services[slot.service.id].slots.push(slot);
                sp.services[slot.service.id].numSlots += slot.staffs.length;
            })

            periods = periods.sort( (a,b) => Date.newFull(a.date) - Date.newFull(b.date) )

            return periods;
        },
        checkoutItems() {
            if (this.reservations.length == 0) {
                return [];
            }

            let items = this.reservations.map((r,index) => ({
                count: 1 + this.extraPersons.length,
                rbservice_id: r.bookings[0].rbservice_id,
                service: this.services.find(s => s.id == r.bookings[0].rbservice_id),
                reservation: r.key,
                slots: r.bookings.map(b => ({start: b.start, end: b.end, staff_id: b.staff_id, rbservice_id: b.rbservice_id, site_id: b.site_id, optional_resources: b.optional_resources, count: b.count})),
                extra_person: this.extraPersons,
                context: {
                    service: this.services.find(s => s.id == r.bookings[0].rbservice_id),
                    start: Date.newFull(r.bookings[0].start),
                    staff: this.staffs.find(s => s.id == r.bookings[0].staff_id),
                    period: this.getPeriod(r.bookings[0].start)
                },
                extended_info: Object.fromEntries(Object.values(r.questions).map(q => ([q.name, q.value]))),
                tmp_id: this.bookingId + '-' + (index+1),
                site_id: r.bookings[0].site_id
            }));

            this.reservations.forEach((r,index) => {
                this.additionalProducts[r.key].forEach(product => {
                    let b = r.basket[product.id];
                    b.forEach(bi => {
                        if (bi.count) {
                            items.push({count: bi.count, rbooking_id: this.bookingId + '-' + (index+1), price: product.price, product_id: product.id, variant: bi.variant})
                        }
                    })
                });
            });

            return items;
        },
        selectedSlotChunk() {
            if (this.selectedDateAndService) {
                let date = this.selectedDateAndService.date;
                let service = this.selectedDateAndService.service;
                let slots = this.wholeWeekSlots;
                let period = this.selectedDateAndService.period;

                let slot = slots.find(slot => slot.date == date && slot.period == period);
                if (slot) {
                    let slotchunk = Object.values(slot.services).find(s => s.service.id == service.id);
                    if (slotchunk) {
                        return {date, period: slot.period, service, slots: slotchunk.slots};
                    }
                }

                return null;
            } else {
                return null;
            }
        },
        // FIXME: move
        numBookings() {
            let b = this.$store.getters.comingBookings;
            if (!b) {
                return 0;
            }

            let res = 0;
            if (b.workouts) {
                res += b.workouts.length;
            }

            if (b.resourcebookings) {
                res += b.resourcebookings.length
            }

            if (b.coursebookings) {
                res += b.coursebookings.length;
            }

            return res;
        },
        steps() {
            if (this.reservations.length == 0) {
                return [];
            }
            let has_questions = this.reservations.find(r => this.services.find(s => s.id == r.bookings[0].rbservice_id).extendedInfo.length);
            let has_additional_products = this.reservations.find(r => this.services.find(s => s.id == r.bookings[0].rbservice_id).additional_products?.length);

            let optional_resources_steps = [];
            this.reservations.forEach(r => {
                let service = this.services.find(s => s.id == r.bookings[0].rbservice_id);
                if (service.resources?.length && !this.$store.state.settings?.modules?.WebShop) {
                    optional_resources_steps = optional_resources_steps.concat(r.bookings.map(b => ({
                        title: this.staffs.find(s => s.id == b.staff_id).name,
                        id: 'optional_resources',
                        context: {
                            resource_name: this.staffs.find(s => s.id == b.staff_id).name,
                            start: b.start,
                            end: b.end,
                            rbservice_id: b.rbservice_id,
                            service,
                            resource_ids: service.resources.map(r => r.id),
                            booking: b,
                            reservation: r,
                            selected_resource_ids: b.optional_resources
                        },
                        complete: true
                    })))
                }
            });
            const pay = this.$translate('Pay');

            let payButtonTitle = this.cost > 0 ? `${pay} ${formatPrice(this.cost)}` : this.$translate('Confirm booking');
            let payTitle = this.cost > 0 ? pay : this.$translate('Confirm booking');
            let showExtraPersons = this.selectedSlotHasCapacity;
            let personsHaveName = this.extraPersons.every(p => p.name);
            let cartDisabled = !this.readyToPayExceptPaymentMethod;
            let extraButton = this.useCart && {label: this.$translate('Add to cart and continue shopping'), clicked: this.addToCart, disabled: cartDisabled};

            return optional_resources_steps.concat([
                showExtraPersons && {title: this.$translate('Book more'), id: 'extra_person', complete: personsHaveName},
                has_questions && {title: this.$translate('Questions'), id: 'questions', complete: this.questionsDone},
                has_additional_products && {title: this.$translate('Optional'), id: 'products', complete: true},
                {title: payTitle, id: 'checkout', nextTitle: payButtonTitle, nextColor: '#7bbd1b', nextDark: true, nextClicked: this.pay, nextLoading: this.checkoutLoading, complete: this.readyToPay, extraButton },
                {title: this.$translate('Done'), id: 'done'}
            ]).filter(x => x);
        },
        additionalProducts() {
            let res = {};
            this.reservations.forEach(r => {
                let service = this.services.find(s => s.id == r.bookings[0].rbservice_id);
                res[r.key] = (service.additional_products || []).map(product_id => this.products.find(product => product.id == product_id)).filter(x => x);
            })

            return res;
        },
        numberOfBookings() {
            return this.reservations.reduce((sum, item) => sum + item.bookings.length, 0)
        },
        isReserving() {
            return !!this.reservations.find(r => !!r.bookings.find(b => b.reserving));
        },
        productsInBasket() {
            return mergeBaskets(this.reservations);
        },
        contactinfo() {
            if (!this.$store.state.settings) {
                return {};
            }

            if (this.$store.state.settings?.sites?.length > 1) {
                let site = this.$store.state.settings.sites.find(x => x.id == this.siteId);
                return {
                    visit_address: site?.address,
                    visit_zipCode: site?.zipCode,
                    visit_city: site?.city
                };
            }
            else {
                return this.$store.state.settings.contactinfo;
            }
        },
        sites() {
            let sites = this.$store.state.settings && this.$store.state.settings.sites;
            return sites?.filter(s => this.services.find(service => service.sites.includes(s.id))).sort( (a,b) => a.name.localeCompare(b.name));
        },
        isBlocked() {
            return this.$store.state.user?.isBlocked('block_resourcebooking');
        },
        showPrice() {
            return !!this.$store.state.settings?.modules?.Payment;
        }
    },
    methods: {
        openGoogle(){
            let address = encodeURI(this.contactinfo.visit_address + ', ' + this.contactinfo.visit_city);
            window.open('https://www.google.se/maps/place/' + address);
        },
        setServices(serviceIds) {
            this.selectedServices = serviceIds.concat();
        },
        getPeriod(time) {
            let startHour = Date.newFull(time).getHours();
            return DAY_PERIODS.find(d => startHour >= d.start && startHour < d.end)
        },
        getFreeSlots() {
            this.reloading = true;
            if(this.throttling) clearTimeout(this.throttling);
            this.throttling = setTimeout(() => {
                this.throttling = null;
                this.getFreeSlotsPerform();
            }, 400);
        },
        getFreeSlotsPerform() {
            this.loadingSlots = true;
            this.showNextButton = false;
            this.showNextWeek = false;
            let start = this.selectedDate.yyyymmdd();
            let end = this.selectedDate.monday().addDays(7).yyyymmdd();
            let staffs = this.filteredStaffs.map(x => x.id).join(',')
            let service = this.filteredServices.map(s => s.id).join(',');
            if (!service) {
                this.reloading = false;
                return;
            }

            let sites = [];
            this.filteredServices.forEach(service => {
                service.sites.forEach(site => {
                    if ((!this.filterSites || !this.filterSites.length || this.filterSites.includes(site)) && !sites.includes(site)) {
                        sites.push(site);
                    }
                })
            })

            let currentIndex = ++this.requestIndex;

            let getpersite = sites.map(site => this.$api.get('/api/public/resourcebooking/get', {service, start, end, staffs, site}));
            Promise.all(getpersite).then(data_per_site => {
                if(currentIndex != this.requestIndex) return;
                let newslots = [];
                data_per_site.forEach((data, index) => {
                    data.forEach(slot => {
                        let toadd = {
                            start: Date.newFull(slot.start),
                            end: Date.newFull(slot.end),
                            staffs: slot.staffs,
                            xstaffs: slot.xstaffs,
                            service: this.filteredServices.find(s => s.id == slot.service_id),
                            key: slot.service_id + '_' + slot.start,
                            period: this.getPeriod(slot.start),
                            site_id: sites[index]
                        };
                        newslots.push(toadd);
                    });
                });
                newslots = newslots.sort((a,b) => a.start - b.start);
                this.slots = newslots;
            }).finally(() => {
                if(currentIndex == this.requestIndex) this.reloading = false
            });

            if (this.filteredServices.length > 1) {
                // FIXME: No support for finding free slots if more than one service is selected
                this.loadingSlots = false;
                this.showNextWeek = true;
                this.showNextButton = true;
                return;
            }
            this.$api.get('/api/public/resourcebooking/get/firstfree', { service: service, start: end, staffs }).then(data => {
                const firstFree = data.start;
                this.firstFreeDate = Date.newFull(firstFree);
                if (data.length === 0) {
                    this.showNextButton = false;
                } else if (this.firstFreeDate < this.selectedDate.clone().addDays(14)) {
                    this.showNextWeek = true;
                    this.showNextButton = true;
                } else {
                    this.showNextWeek = false;
                    this.showNextButton = true;
                }
                this.loadingSlots = false;
            }).catch(() => {
                this.showNextButton = false;
                this.loadingSlots = false;
            });
        },
        formatTimePeriodPart(date, period, skipPeriod) {
            date = Date.newFull(date);
            // FIXME: Better for translation

            let when = '';
            if (date.isToday()) {
                if (!skipPeriod && period.id == 'morning') {
                    when = this.$translate('Today') + ', ' + period.short;
                } else if(!skipPeriod && period) {
                    when = 'I ' + period.short;
                } else {
                    when = this.$translate('Today');
                }
            } else if (Date.dateEquals(date, Date.tomorrow())) {
                if (period && !skipPeriod) {
                    when = this.$translate('Tomorrow') + ' ' + period.short;
                } else {
                    when = this.$translate('Tomorrow');
                }
            }

            if (when) {
                when += ', ';
            }

            return when;
        },
        formatTimeDatePart(date, long) {
            date = Date.newFull(date);
            let weekday = this.$translate(date.getWeekDayString());
            if (!long) {
                weekday = weekday.substring(0, 3);
            }

            let lc = (x) => this.$store.state.language == 'sv' ? x.toLowerCase() : x;
            return `${lc(weekday)} ${date.getDate()} ${lc(this.$translate(long ? date.getMonthName() : date.getMonthNameShort()))}`;
        },
        formatTime(date, period, skipPeriod) {
            let when = this.formatTimePeriodPart(date, period, skipPeriod);
            return `${when}${this.formatTimeDatePart(date)}`;
        },
        formatTimeLonger(date) {
            let when = this.formatTimePeriodPart(date, null, true);
            return `${when}${this.formatTimeDatePart(date, true)}`.capitalize();
        },
        onePerStaff(slots) {
            let res = [];
            let reserved = slots.filter(slot => slot.reserved);
            slots.forEach(slot => {
                slot.staffs.forEach(staffId => {
                    if (!slot.reserved && reserved.length) {
                        if (reserved.find(x => x.start.dateTime() == slot.start.dateTime() && x.staffs[0] == staffId && x.service.id == slot.service.id)) {
                            return;
                        }
                    }
                    if (this.filteredStaffs && this.filteredStaffs.length && !this.filteredStaffs.find(x => x.id == staffId)) {
                        return;
                    }

                    let staff = this.staffs.find(x => x.id == staffId);
                    res.push({
                        start: slot.start,
                        end: slot.end,
                        service: slot.service,
                        period: slot.period,
                        key: slot.key + staffId + slot.reserved,
                        staff: staff,
                        xstaffs: slot.xstaffs,
                        orginalSlot: slot,
                        reserved: slot.reserved,
                        reserving: slot.reserving
                    });
                })
            })
            res = res.sort((a,b) => {
                if (a.start.dateTime() == b.start.dateTime()) {
                    return a.staff.name.localeCompare(b.staff.name);
                }

                return a.start - b.start;
            });
            return res;
        },
        reserve(slot) {
            let reservedSlot = {start: slot.start.dateTime(), end: slot.end.dateTime(), rbservice_id: slot.service.id, staff_id: slot.staff.id, reserving: true, site_id: slot.orginalSlot.site_id, optional_resources: [], count: 1};
            if(slot.xstaffs.length) {
                reservedSlot.xstaff_id = slot.xstaffs[Math.floor(Math.random() * slot.xstaffs.length)];
            }
            let r = this.reservations.find(r => r.bookings.find(b => b.rbservice_id == slot.service.id && b.site_id == reservedSlot.site_id));
            if (!r) {
                r = {bookings: [], key: null, replace: true, basket: {}}
                this.reservations.push(r);
            }
            r.bookings.push(reservedSlot);

            this.$api.post('/api/resource/reservation/add_resourcebooking', r).then(response => {
                if (response.ok) {
                    response.json().then(x => {
                        r.key = x.key;
                        reservedSlot.reserving = false;

                        try {
                            let ecommerceTrackingItem = {
                                id: 'r' + reservedSlot.rbservice_id,
                                count: reservedSlot.count
                            };

                            let service = this.services.find((s) => s.id == reservedSlot.rbservice_id);
                            if (service) {
                                ecommerceTrackingItem.name = service.name;
                                ecommerceTrackingItem.price = service.price;
                                ecommerceTrackingItem.vat = service.vat;

                                this.$ecommercetracking.addToCart(ecommerceTrackingItem);
                            }
                        } catch(error) {
                            Sentry.captureException(error);
                        }
                    });
                } else {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error during reservation'), text: this.$translate('Something went wrong when the booking was to be reserved')});
                }
            })
        },
        unreserve(slot) {
            let afterUnreserve = (cb) => {
                let unwatch = this.$watch('slots', () => {
                    cb();
                    unwatch();
                    unwatch = null;
                });
                setTimeout(() => {
                    if (unwatch) {
                        unwatch();
                    } else {
                        cb();
                    }
                }, 3000);
            }

            let r = this.reservations.find(r => r.bookings.find(b => b.rbservice_id == slot.service.id));
            if (r) {
                let b = r.bookings.find(b => b.start == slot.start.dateTime() && b.staff_id == slot.staff.id);
                if (b) {
                    b.reserving = true;
                    if (r.bookings.length == 1) {
                        this.$api.post('/api/resource/reservation/cancel', {key: r.key}).then(() => {
                            afterUnreserve(() => {
                                let idx = this.reservations.indexOf(r);
                                if (idx != -1) {
                                    this.reservations.splice(idx, 1)
                                }
                            })
                        });
                    } else  {
                        this.$api.post('/api/resource/reservation/add_resourcebooking', {...r, bookings: r.bookings.filter(i => i != b)}).then(response => {
                            if (response.ok) {
                                response.json().then(x => {
                                    afterUnreserve(() => {
                                        this.$delete(r.bookings, r.bookings.indexOf(b))
                                        r.key = x.key;
                                    });
                                })
                            } else {
                                this.$store.commit('showErrorDialog', {title: this.$translate('Error during reservation'), text: this.$translate('Something went wrong when the booking was to be reserved')});
                            }
                        })
                    }
                }
            }
        },
        updateReservation(r) {
            r.bookings.forEach(b => b.reserving = true);
            this.$api.post('/api/resource/reservation/add_resourcebooking', r).then(response => {
                if (response.ok) {
                    response.json().then(() => {
                        r.bookings.forEach(b => b.reserving = false);
                    })
                } else {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error during reservation'), text: this.$translate('Something went wrong when the booking was to be reserved')});
                }
            })
        },
        unreserveAll(wait) {
            let keys = this.reservations.map(r => r.key);

            // Checkout is loading, don't unreserve
            if (this.checkoutLoading) { return }

            if (keys.length) {
                this.$api.post('/api/resource/reservation/cancel', {key: keys}).then(() => {
                    let unreserve = () => {
                        keys.forEach(key => {
                            let idx = this.reservations.findIndex(r => r.key == key);
                            if (idx != -1) {
                                this.reservations.splice(idx, 1);
                            }
                        });
                    }

                    if (wait) {
                        let unwatch = this.$watch('slots', unreserve);

                        setTimeout(() => {
                            if (unwatch) {
                                unwatch();
                            } else {
                                unreserve();
                            }
                        }, 3000);
                    } else {
                        unreserve();
                    }
                });
            }
        },
        async bookWithoutWebShop() {
            this.checkoutLoading = true;

            for (let r of this.reservations) {
                let bookings = r.bookings.map(b => ({
                    start: b.start,
                    end: b.end,
                    staff: b.staff_id,
                    service: b.rbservice_id,
                    extendedInfo: Object.fromEntries(Object.values(r.questions).map(q => ([q.name, q.value])))
                }));

                let optional_resource = r.bookings.map(b => ({
                    room_id: b.staff_id,
                    resources: b.optional_resources
                }));

                try {
                    let response = await this.$api.post('/api/memberapi/resourcebooking/add', {
                        bookings,
                        _extra_info: {
                            reservation: [r.key],
                            extra_person: this.extraPersons,
                            _additional_products: null
                        },
                        optional_resource
                    });

                    if (!response.ok) {
                        throw new Error(this.$translate('Booking error'));
                    }
                } catch (error) {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Booking error'), text: error.message });
                    this.checkoutLoading = false;
                    return;
                }
            }

            this.reset();
            this.$store.commit('showCheckoutDoneDialog', { thankYouText: this.$translate('Booking completed') });
            this.checkoutLoading = false;
        },
        pay() {
            if (this.$store.state.settings?.modules?.WebShop) {
                this.$refs.checkout.completePurchase();
            } else {
                this.bookWithoutWebShop();
            }
        },
        checkoutDone() {
            this.reservations = [];
            this.reset();
        },
        reset() {
            this.selectedDateAndService = null;
            this.selectedSlot = null;
            this.unreserveAll(false);
            this.showCheckout = false;
            this.basket = {};
            this.almostdone = false;
            this.currentStep = 0;
            this.extraPersons = [];
            this.selectedSlotHasCapacity = null;
            this.bookingId = getRandomId(8);
        },
        getPosX(ref) {
            return ref?.$el.getBoundingClientRect().left;
        },
        getPosBottomY(ref) {
            let br = ref?.$el.getBoundingClientRect();
            if (br) {
                return br.top + br.height;
            }

            return null;
        },
        dateChanged() {
            this.showDatePicker = false;
        },
        prevWeek() {
            this.selectedDate = new Date(Math.max(this.selectedDate.clone().addDays(-7).monday(), Date.today()));
        },
        nextWeek() {
            this.selectedDate = this.selectedDate.clone().addDays(7).monday();
        },
        nextAvailable() {
            if (this.firstFreeDate) {
                this.selectedDate = this.firstFreeDate.clone();
            }
        },
        zeropad(x) {
            return (x < 10) ? '0' + x : x;
        },
        goto(link) {
            if (this.$route.path != link) {
                this.$router.push({path: link});
            }
        },
        gotoMyPages() {
            let link = this.$root.getDefaultPage('mypages');
            if (this.$route.path != link) {
                this.goto(link);
            }
        },
        changeTime() {
            if (!this.checkoutLoading) {
                this.$refs.stepper.setStep(this.$refs.stepper.currentStep, this.steps.findIndex(x => x.id == 'time'));
                this.unreserve();
            }
        },
        slotClicked(slot) {
            if (slot.reserving || this.isBlocked) {
                return;
            }
            if (slot.reserved) {
                this.unreserve(slot);
            } else {
                this.reserve(slot);
            }
        },
        changeNumberOfItems(item, count) {
            if (item.rbooking_id) {
                let index = Number(item.rbooking_id.split('-')[1]) - 1;
                let r = this.reservations[index];
                let b = r.basket[item.product_id];
                let bi = b?.find(bi => bi.variant === item.variant);
                if (bi) {
                    bi.count = count;
                }
            }
        },
        setItem(list, id, selected) {
            let i = list.indexOf(id);
            if (selected && i == -1) {
                list.push(id);
            } else if (!selected && i != -1) {
                list.splice(i, 1);
            }
        },
        optionalResourceSelected(reservation, booking, resource_id, selected) {
            let i = booking.optional_resources.indexOf(resource_id);
            if (!selected) {
                // Remove from booking.optional_resources
                if (i != -1) {
                    booking.optional_resources.splice(i, 1);
                }
            } else {
                // Add to booking.optional_resources unless already added
                if (i == -1) {
                    booking.optional_resources.push(resource_id);
                }
            }

            this.updateReservation(reservation);
        },
        addExtraPerson() {
            this.extraPersons.push({name: this.$translate('Participant {0}').format(this.extraPersons.length + 2)});
            this.reservations.forEach(reservation => {
                reservation.count = this.extraPersons.length + 1;
                this.updateReservation(reservation);
            });
        },
        removeExtraPerson(index) {
            this.extraPersons.splice(index, 1);
            this.reservations.forEach(reservation => {
                reservation.count = this.extraPersons.length + 1;
                this.updateReservation(reservation);
            });
        },
        checkAvailabilityForReservedSlots() {
            let bookings = this.reservations.map(r => r.bookings.map(b => {
                let service = this.services.find(s => s.id == b.rbservice_id);
                let resource_ids = service.xstaffs.map(x => x.id);
                resource_ids.push(b.staff_id);
                return {
                    resource_ids: resource_ids,
                    start: b.start,
                    end: b.end,
                    rbservice_id: b.rbservice_id,
                    staff_id: b.staff_id
                };
            })).flat();

            if (bookings.length == 0) {
                this.seatsLeft = null;
                return;
            }

            this.checkingAvailability = true;
            this.$api.post('/api/resource/availability/slots/get', {bookings, mode: 'full'}).then(response => {
                response.json().then(data => {
                    let availabilities = Object.values(data.availability)
                    let min = availabilities.reduce((a, b) => Math.min(a, b));
                    this.seatsLeft = min;
                    if (this.selectedSlotHasCapacity === null) {
                        let capacities = Object.values(data.capacity)
                        let minCapacity = capacities.reduce((a, b) => Math.min(a, b));
                        this.selectedSlotHasCapacity = minCapacity > 1;
                    }
                    this.checkingAvailability = false;
                });
            })
        },
        addToCart() {
            const props = ['count', 'rbservice_id', 'reservation', 'slots', 'extra_person', 'extended_info', 'tmp_id', 'site_id', 'rbooking_id', 'product_id', 'variant', 'price', 'service'];

            const cartName = this.cartName;
            this.checkoutItems.forEach(item => {
                let basketItem = {};
                props.forEach(prop => {
                    if (item[prop] !== undefined) {
                        basketItem[prop] = item[prop];
                    }
                });
                this.$store.dispatch('addToCart', basketItem);
            })
            this.$store.dispatch('setCartVisibility', {cartName, showBottomBar: true, showCheckout: false});
            // Close dialog without removing reservations
            this.reservations = [];
            this.showCheckout = false;
        },
        reservationTimeout() {
            this.showCheckout = false;
        },
        ecommerceViewItemFunction(item) {
            try {
                let ecommerceTrackingItem = {
                    id: 'r' + item.service.id,
                    name: item.service.name,
                    price: item.service.price,
                    vat: item.service.vat,
                };
                this.$ecommercetracking.viewItem(ecommerceTrackingItem);
            } catch(error) {
                Sentry.captureException(error);
            }
        },
    },
    created() {
        this.unsubscribe = this.$root.$api.subscribe({type: 'resourceallocation', callback: () => {
            this.getFreeSlots();
            this.checkAvailabilityForReservedSlots();
        }});
        window.addEventListener('beforeunload', this.unreserveAll);
    },
    destroyed() {
        this.unreserveAll();
        window.removeEventListener('beforeunload', this.unreserveAll);
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }
}
</script>

<!--

Singelbokning

MUST: Problem med att tiderna inte hänger med vid reservation av multibokning. Server och klient diffar

Nice: Fixa så att <v-expand-transition> fungerar

MUST: Undersök: Dialogen måste rensas när man öppnar den igen
MUST: Undersök: unreserve när man filtrerar om eller byter dag
MUST: Undersök: unreserve när man stänger tider (?)
MUST: Undersök: endast en panel kan vara utfälld
Nice: Finns bara en staff: visa då bara den personen
Nice: Finns bara en tjänst: visa då bara tjänsten
Nice: Animation när vara läggs till om man redan har en
Nice: Alignment för <product-dialog>

-->
